export const peopleRoute = `/people`;
export const teamsRoute = `${peopleRoute}/teams`;
